import { render, staticRenderFns } from "./SectionWriter.vue?vue&type=template&id=ab0343a0&"
import script from "./SectionWriter.vue?vue&type=script&lang=ts&"
export * from "./SectionWriter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports